import { Classified } from 'lib/types/classified';
import { NewspaperOrder } from 'lib/types/newspaperOrder';
import { Obituary } from 'lib/types/obituary';

export const isPlacementFormForVersion = ({
  adFormData,
  newspaperOrdersFormData,
  orderId,
  version
}: {
  adFormData: Partial<Obituary | Classified>;
  newspaperOrdersFormData: Partial<NewspaperOrder>[];
  orderId: string;
  version: number;
}): boolean => {
  const adMatches =
    (adFormData.order === undefined || adFormData.order.id === orderId) &&
    (adFormData.orderVersion === undefined ||
      adFormData.orderVersion === version);
  // Newspaper orders added in this session have no orderVersion until they are saved.
  const newspaperOrdersMatch = newspaperOrdersFormData.every(
    newspaperOrder =>
      newspaperOrder.orderVersion === undefined ||
      newspaperOrder.orderVersion === version
  );
  return adMatches && newspaperOrdersMatch;
};
